import React from 'react';
import App from './components/App';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';

// Router 로 감싸서 root 컴포넌트 생성
const Root = () => (
  <BrowserRouter>
        <App />
  </BrowserRouter>
);

// 리엑트 렌더링 시작
ReactDOM.render(<Root />, document.getElementById('root'));
